import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
const baseApiUrl = '';
@Injectable({
  providedIn: 'root'
})
export class SearchIpServiceService {

  constructor(
    private http: HttpClient
  ) { }

  searchIpaddress(data: any): Observable<any> {
    return this.http.post<any>(baseApiUrl + "ippool/ipFind", data);
  }
}
